import * as React from 'react';
import styled from 'styled-components';
import { Container } from '../../../theme/libraries/grid';
import { rem } from 'polished';
import { ContentContainersStyles } from './ContentContainer';

const Layout = styled(Container)`
  display: flex;
  align-items: flex-start;
  padding: 0;
  ${({ theme }) => theme.media('md')} {
    /* Match the catalog (category / product) pages: a 15px page gutter so the
       sidebar aligns flush under the header's 272px panel area instead of bleeding
       to the viewport edge. */
    padding-left: ${rem(15)};
    padding-right: ${rem(15)};
    margin-bottom: ${rem(20)};
  }

  & > *:last-child {
    flex: 1 1 0%;
    min-width: 0;
    ${ContentContainersStyles};
    /* A 30px side-menu→content gap (left padding) and a small ~8px offset below
       the header (top padding), with even side gutters. */
    ${({ theme }) => theme.media('md')} {
      padding: ${rem(8)} ${rem(15)} ${rem(20)} ${rem(30)};
    }
  }
`;

interface Props {
  children: any;
  noPadding?: boolean;
}

const ContentContainerWithSidebar = (props: Props) => (
  <Layout className="base">{props.children}</Layout>
);

export default ContentContainerWithSidebar;
